// GENERATED from classes.store by tools/classes-store.js — do not edit.
// Edit the store (or `npm run knobs`, Classes tab), then re-run the generator.
// The store is the single source of truth; this module is its projection
// (the committed default table — the sim ignores it until the classes phase).
export const CLASSES_DATA = {
  "xp": [0,100,300,700,1500],
  "levels": [
    { "level": 1, "atkBonus": 0, "dmgMod": 100, "maxHp": 30 },
    { "level": 2, "atkBonus": 1, "dmgMod": 105, "maxHp": 45 },
    { "level": 3, "atkBonus": 2, "dmgMod": 110, "maxHp": 60 },
    { "level": 4, "atkBonus": 3, "dmgMod": 115, "maxHp": 75 },
    { "level": 5, "atkBonus": 4, "dmgMod": 120, "maxHp": 90 },
  ],
  "classes": [
    {
      "kind": "knight",
      "name": "Knight",
      "meleeWeaponEfficiencyPct": 125,
      "magicWeaponEfficiencyPct": 50,
      "abilities": [
        { "id": 0, "name": "Enhanced Strike", "kind": "next-hit-bonus", "atkClass": "melee", "levels": [
          { "magnitude": 110, "cooldown": 300, "extra": null },
          { "magnitude": 120, "cooldown": 280, "extra": null },
          { "magnitude": 130, "cooldown": 260, "extra": null },
          { "magnitude": 140, "cooldown": 240, "extra": null },
          { "magnitude": 175, "cooldown": 220, "extra": null },
        ] },
        { "id": 1, "name": "Barricade", "kind": "damage-immune", "atkClass": "melee", "levels": [
          { "magnitude": 100, "cooldown": 600, "extra": 100 },
          { "magnitude": 100, "cooldown": 560, "extra": 120 },
          { "magnitude": 100, "cooldown": 520, "extra": 140 },
          { "magnitude": 100, "cooldown": 480, "extra": 160 },
          { "magnitude": 100, "cooldown": 440, "extra": 180 },
        ] },
        { "id": 2, "name": "Phoenix Teleport", "kind": "phoenix-teleport", "atkClass": "melee", "levels": [
          { "magnitude": 100, "cooldown": 1, "extra": null },
          { "magnitude": 100, "cooldown": 1, "extra": null },
          { "magnitude": 100, "cooldown": 1, "extra": null },
          { "magnitude": 100, "cooldown": 1, "extra": null },
          { "magnitude": 100, "cooldown": 1, "extra": null },
        ] },
      ],
    },
    {
      "kind": "mage",
      "name": "Mage",
      "meleeWeaponEfficiencyPct": 50,
      "magicWeaponEfficiencyPct": 100,
      "abilities": [
        { "id": 0, "name": "Reflect", "kind": "damage-reflect", "atkClass": "magic", "levels": [
          { "magnitude": 50, "cooldown": 600, "extra": 100 },
          { "magnitude": 50, "cooldown": 560, "extra": 120 },
          { "magnitude": 50, "cooldown": 520, "extra": 140 },
          { "magnitude": 50, "cooldown": 480, "extra": 160 },
          { "magnitude": 50, "cooldown": 440, "extra": 180 },
        ] },
        { "id": 1, "name": "Chain", "kind": "next-hit-chain", "atkClass": "magic", "levels": [
          { "magnitude": 100, "cooldown": 300, "extra": 2 },
          { "magnitude": 105, "cooldown": 280, "extra": 2 },
          { "magnitude": 110, "cooldown": 260, "extra": 3 },
          { "magnitude": 115, "cooldown": 240, "extra": 3 },
          { "magnitude": 130, "cooldown": 220, "extra": 3 },
        ] },
        { "id": 2, "name": "Cull", "kind": "room-aoe", "atkClass": "magic", "levels": [
          { "magnitude": 100, "cooldown": 800, "extra": null },
          { "magnitude": 105, "cooldown": 750, "extra": null },
          { "magnitude": 110, "cooldown": 700, "extra": null },
          { "magnitude": 115, "cooldown": 650, "extra": null },
          { "magnitude": 125, "cooldown": 600, "extra": null },
        ] },
      ],
    },
    {
      "kind": "squire",
      "name": "Squire",
      "meleeWeaponEfficiencyPct": 100,
      "magicWeaponEfficiencyPct": 100,
      "abilities": [
        { "id": 0, "name": "Sprint", "kind": "speed-buff", "atkClass": "melee", "levels": [
          { "magnitude": 125, "cooldown": 800, "extra": 400 },
          { "magnitude": 130, "cooldown": 760, "extra": 420 },
          { "magnitude": 135, "cooldown": 720, "extra": 440 },
          { "magnitude": 140, "cooldown": 680, "extra": 460 },
          { "magnitude": 150, "cooldown": 640, "extra": 500 },
        ] },
        { "id": 1, "name": "Blink", "kind": "teleport", "atkClass": "melee", "levels": [
          { "magnitude": 100, "cooldown": 600, "extra": null },
          { "magnitude": 100, "cooldown": 560, "extra": null },
          { "magnitude": 100, "cooldown": 520, "extra": null },
          { "magnitude": 100, "cooldown": 480, "extra": null },
          { "magnitude": 100, "cooldown": 440, "extra": null },
        ] },
        { "id": 2, "name": "Telegrab", "kind": "telegrab", "atkClass": "melee", "levels": [
          { "magnitude": 100, "cooldown": 900, "extra": null },
          { "magnitude": 100, "cooldown": 860, "extra": null },
          { "magnitude": 100, "cooldown": 820, "extra": null },
          { "magnitude": 100, "cooldown": 780, "extra": null },
          { "magnitude": 100, "cooldown": 740, "extra": null },
        ] },
      ],
    },
  ],
} as const;
